// import React, { useEffect, useRef, useState } from "react";
// import html2pdf from "html2pdf.js";
// import { useSelector } from "react-redux";
// import { mgt1Api } from "../registerFormApi/Mgt1";

// const PAGE = {
//   width: "297mm",          // A4 landscape width
//   minHeight: "210mm",      // A4 landscape height
//   padding: "12mm 14mm",
//   fontFamily: "'Times New Roman', Times, serif",
//   fontSize: "9px",
//   color: "#000",
//   boxSizing: "border-box",
//   background: "#fff",
//   pageBreakAfter: "always",
// };

// const CENTER_BLOCK = { textAlign: "center", marginBottom: "6px" };

// const LABEL_CELL = {
//   width: "210px",
//   minWidth: "210px",
//   verticalAlign: "top",
//   paddingRight: "6px",
//   fontWeight: "normal",
//   whiteSpace: "nowrap",
// };

// const VALUE_CELL = {
//   verticalAlign: "top",
//   paddingLeft: "2px",
//   fontWeight: "normal",
// };

// /* ─────────────────────────────────────────────
//    COMPONENT
//    ───────────────────────────────────────────── */
// const Mgt1RegisterViewer = ({ selectedClientData }) => {
//   const token = useSelector((state) => state.auth.access_token);
//   const [registerData, setRegisterData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const printRef = useRef(null);

//   /* ─── FETCH (unchanged API call) ─── */
//   const fetchRegisterData = async () => {
//     if (!selectedClientData || !token) return;
//     const accountId = selectedClientData.accountId || selectedClientData.id;
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await mgt1Api.fetchMgt1Register(accountId, token);
//       console.log("MGT-1 RESPONSE 👉", res);
//       setRegisterData(Array.isArray(res) ? res : []);
//     } catch (err) {
//       console.error("MGT-1 fetch error:", err);
//       setError("Failed to load MGT-1 data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRegisterData();
//   }, [selectedClientData?.id, token]);

//   /* ─── PDF EXPORT ─── */
//   const handlePrintToPDF = async () => {
//     if (!printRef.current) return;
//     await html2pdf()
//       .set({
//         margin: 0,
//         filename: `MGT1_Register_${selectedClientData?.accountName || "Company"}.pdf`,
//         image: { type: "jpeg", quality: 0.98 },
//         html2canvas: { scale: 2, useCORS: true },
//         jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
//         pagebreak: { mode: ["css", "legacy"] },
//       })
//       .from(printRef.current)
//       .save();
//   };

//   /* ─── HELPERS ─── */
//   const fmt = (d) => {
//     if (!d) return "-";
//     try {
//       return new Date(d).toLocaleDateString("en-GB", {
//         day: "2-digit",
//         month: "2-digit",
//         year: "numeric",
//       });
//     } catch {
//       return "-";
//     }
//   };

//   const cur = (v) => (v || v === 0 ? `₹${Number(v).toLocaleString("en-IN")}` : "-");
//   const val = (v) => (v !== null && v !== undefined && v !== "" ? String(v) : "-");

//   /* ─── LOADING / ERROR / EMPTY ─── */
//   if (!selectedClientData)
//     return <p className="text-center text-gray-500 mt-10">Select an account</p>;
//   if (loading)
//     return <p className="text-center text-gray-500 mt-10">Loading MGT-1…</p>;
//   if (error)
//     return <p className="text-center text-red-600 mt-10">{error}</p>;
//   if (registerData.length === 0)
//     return <p className="text-center text-gray-500 mt-10">No MGT-1 data found</p>;

//   /* ─── RENDER ─── */
//   return (
//     <div className="bg-gray-100 p-4">
//       {/* ── toolbar ── */}
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="font-bold text-lg">MGT-1 Register of Members</h2>
//         <div className="flex gap-2">
//           <button
//             onClick={fetchRegisterData}
//             className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded text-sm font-semibold"
//           >
//             🔄 Reload
//           </button>
//           <button
//             onClick={handlePrintToPDF}
//             className="bg-green-600 hover:bg-green-700 text-white px-4 py-1.5 rounded text-sm font-semibold"
//           >
//             📄 Export PDF
//           </button>
//         </div>
//       </div>

//       {/* ── printable pages ── */}
//       <div ref={printRef}>
//         {registerData.map((member, i) => {
//           const pd = member.personalDetails || {};
//           const md = member.memberMinorDetails || {};
//           const ms = md.memberShipDetails || {};
//           const addr = member.registeredOfficeAddress || {};
//           const holdings = member.mgt1ShareHolding || [];

//           return (
//             <div
//               key={i}
//               style={PAGE}
//               className="shadow-md mx-auto mb-6"
//             >
//               {/* ══════ HEADER ══════ */}
//               <div style={CENTER_BLOCK}>
//                 <div style={{ fontSize: "13px", fontWeight: "bold" }}>Form No. MGT - 1</div>
//                 <div style={{ fontSize: "11px", fontWeight: "bold" }}>Register of members</div>
//                 <div style={{ fontSize: "8px", marginTop: "2px" }}>
//                   [Pursuant to section 88 (1)(a) of the Companies Act, 2013 and rule 3(1) of the Companies (Management and Administration) Rules, 2014]
//                 </div>
//               </div>

//               {/* ══════ TWO-COLUMN INFO BLOCK ══════ */}
//               <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "9px" }}>
//                 <tbody>
//                   {/* Company top fields */}
//                   <tr>
//                     <td style={{ ...LABEL_CELL, fontWeight: "bold" }}>Name of the Company:</td>
//                     <td style={VALUE_CELL}>{val(member.companyName)}</td>
//                   </tr>
//                   <tr>
//                     <td style={LABEL_CELL}>Registered office address:</td>
//                     <td style={VALUE_CELL}>
//                       {addr.address
//                         ? `${addr.address}, ${addr.city || ""}, ${addr.state || ""}, ${addr.pincode || ""}`
//                         : "-"}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td colSpan={2} style={{ fontSize: "7.5px", fontStyle: "italic", color: "#555", paddingBottom: "3px" }}>
//                       TO BE MAINTAINED SEPARATELY FOR EACH CLASS OF SHARES
//                     </td>
//                   </tr>
//                   <tr>
//                     <td style={LABEL_CELL}>Class of shares:</td>
//                     <td style={VALUE_CELL}>{val(member.shareClass)}</td>
//                   </tr>
//                   <tr>
//                     <td style={LABEL_CELL}>Nominal value per share (in Rs.):</td>
//                     <td style={VALUE_CELL}>{val(member.nominalValuePerShare)}</td>
//                   </tr>
//                   <tr>
//                     <td style={LABEL_CELL}>Total shares held:</td>
//                     <td style={VALUE_CELL}>{val(member.totalSharesHeld)}</td>
//                   </tr>
//                   <tr>
//                     <td style={{ ...LABEL_CELL, fontWeight: "bold" }}>FOLIO NO.</td>
//                     <td style={{ ...VALUE_CELL, fontWeight: "bold" }}>{val(member.folio_no)}</td>
//                   </tr>
//                 </tbody>
//               </table>

//               {/* ══════ PERSONAL DETAILS + MINOR DETAILS (side by side) ══════ */}
//               <div style={{ display: "flex", gap: "18px", marginTop: "8px", fontSize: "9px" }}>
//                 {/* ── Left: Personal details ── */}
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontWeight: "bold", marginBottom: "3px", borderBottom: "1px solid #000", paddingBottom: "2px" }}>
//                     Personal details
//                   </div>
//                   <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                     <tbody>
//                       <PersonalRow label="Name of the member" value={pd.memberName} />
//                       <PersonalRow label="Name of joint holders, if any" value={pd.jointHoldersName} />
//                       <PersonalRow label="Address / Registered address (in case of body corporate):" value={pd.addressOrRegisteredAddress} />
//                       <PersonalRow label="E-mail Id" value={pd.emailId} />
//                       <PersonalRow label="CIN / Registration No." value={pd.cinOrRegistrationNo} />
//                       <PersonalRow label="Unique Identification No" value={pd.uniqueIdentificationNo} />
//                       <PersonalRow label="Father's / Mother's / Spouse's name" value={pd.parentOrSpouseName} />
//                       <PersonalRow label="Status" value={pd.status} />
//                       <PersonalRow label="Occupation" value={pd.occupation} />
//                       <PersonalRow label="PAN" value={pd.panNo} />
//                       <PersonalRow label="Nationality" value={pd.nationality} />
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* ── Right: In case member is a minor + membership details ── */}
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontWeight: "bold", marginBottom: "3px", borderBottom: "1px solid #000", paddingBottom: "2px" }}>
//                     In case member is a minor,
//                   </div>
//                   <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                     <tbody>
//                       <PersonalRow label="Name of Guardian" value={md.guardianName} />
//                       <PersonalRow label="Date of birth of minor" value={fmt(md.dateOfBirthOfMinor)} />
//                       <PersonalRow label="Date of becoming member" value={fmt(md.dateOfBecomingMember)} />
//                       <PersonalRow label="Details of membership" value={null} />
//                       <PersonalRow label="Date of declaration under section 89, if applicable" value={fmt(ms.declarationDateUnderSection89)} />
//                       <PersonalRow label="Name and address of beneficial owner" value={ms.beneficialOwnerNameAndAddress} />
//                       <PersonalRow label="Date of receipt of nomination, if applicable" value={fmt(ms.nominationReceiptDate)} />
//                       <PersonalRow label="Name and address of nominee" value={ms.nomineeNameAndAddress} />
//                       <PersonalRow label="No. of shares kept in abeyance, if applicable" value={ms.sharesKeptInAbeyance} />
//                       <PersonalRow label="Record of lien on shares, if applicable" value={ms.lienOnShares} />
//                       <PersonalRow label="Date of cessation of membership" value={fmt(ms.dateOfCessationOfMembership)} />
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               {/* ══════ INSTRUCTIONS ══════ */}
//               <div style={{ marginTop: "10px", fontSize: "8px" }}>
//                 <div style={{ fontWeight: "bold", marginBottom: "2px" }}>Instructions</div>
//                 <div>Particulars of dividend mandates, power of attorney and other instructions, if any:</div>
//                 <div>Instruction for sending notices etc., if any:</div>
//               </div>

//               {/* ══════ DETAILS OF SHARE HOLDING TABLE ══════ */}
//               <div style={{ marginTop: "8px" }}>
//                 <div style={{ fontWeight: "bold", marginBottom: "4px", fontSize: "9px" }}>Details of share holding</div>
//                   <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "7px", tableLayout: "fixed" }}>
//                     {/* ── colgroup: 23 columns, each ~4.35% ── */}
//                     <colgroup>
//                       <col style={{ width: "5.2%" }} />  {/* (1)  Allotment No */}
//                       <col style={{ width: "4.8%" }} />  {/* (2)  Date of allotment */}
//                       <col style={{ width: "4.2%" }} />  {/* (3)  No of shares */}
//                       <col style={{ width: "3.8%" }} />  {/* (4a) Distinctive From */}
//                       <col style={{ width: "3.8%" }} />  {/* (4b) Distinctive To */}
//                       <col style={{ width: "3.8%" }} />  {/* (5)  Folio of transferor */}
//                       <col style={{ width: "5.5%" }} />  {/* (6)  Name of transferor */}
//                       <col style={{ width: "5.0%" }} />  {/* (7)  Date of issue/endorsement */}
//                       <col style={{ width: "4.0%" }} />  {/* (8)  Certificate No */}
//                       <col style={{ width: "4.0%" }} />  {/* (9)  Lock in period */}
//                       <col style={{ width: "4.2%" }} />  {/* (10a) Payable */}
//                       <col style={{ width: "4.8%" }} />  {/* (10b) Paid/Deemed */}
//                       <col style={{ width: "3.5%" }} />  {/* (10c) Due */}
//                       <col style={{ width: "5.2%" }} />  {/* (11) Consideration other than cash */}
//                       <col style={{ width: "4.8%" }} />  {/* (12) Date of transfer/transmission */}
//                       <col style={{ width: "4.2%" }} />  {/* (13) No of shares transferred */}
//                       <col style={{ width: "3.5%" }} />  {/* (14a) Distinctive From */}
//                       <col style={{ width: "3.5%" }} />  {/* (14b) Distinctive To */}
//                       <col style={{ width: "3.8%" }} />  {/* (15) Folio of transferee */}
//                       <col style={{ width: "5.0%" }} />  {/* (16) Name of transferee */}
//                       <col style={{ width: "5.2%" }} />  {/* (17) Balance shares */}
//                       <col style={{ width: "3.8%" }} />  {/* (18) Remarks */}
//                       <col style={{ width: "4.5%" }} />  {/* (19) Auth/Signature */}
//                     </colgroup>

//                     <thead>
//                       {/* ── Row 1: top-level merged headers ── */}
//                       <tr style={{ background: "#f0f0f0" }}>
//                         <th rowSpan={3} style={TH}>Allotment No./<br/>Transfer No.</th>
//                         <th rowSpan={3} style={TH}>Date of<br/>allotment/<br/>transfer</th>
//                         <th rowSpan={3} style={TH}>No. of shares<br/>allotted/<br/>transferred</th>
//                         <th colSpan={2} style={TH}>Distinctive numbers<br/>(both inclusive)</th>
//                         <th rowSpan={3} style={TH}>Folio of<br/>transferor, if<br/>applicable</th>
//                         <th rowSpan={3} style={TH}>Name of the<br/>transferor, if<br/>applicable</th>
//                         <th rowSpan={3} style={TH}>Date of issue or<br/>endorsement of<br/>share certificate</th>
//                         <th rowSpan={3} style={TH}>Certificate<br/>No.</th>
//                         <th rowSpan={3} style={TH}>Lock in<br/>period, if any</th>
//                         <th colSpan={3} style={TH}>Amount (Rs)</th>
//                         <th rowSpan={3} style={TH}>If shares are<br/>issued for<br/>consideration<br/>other than cash,<br/>brief particulars<br/>thereof</th>
//                         <th rowSpan={3} style={TH}>Date of<br/>transfer/<br/>transmission/<br/>redemption etc</th>
//                         <th rowSpan={3} style={TH}>No. of shares<br/>transferred/<br/>forfeited/<br/>redeemed etc</th>
//                         <th colSpan={2} style={TH}>Distinctive numbers<br/>(both inclusive)</th>
//                         <th rowSpan={3} style={TH}>Folio of<br/>transferee</th>
//                         <th rowSpan={3} style={TH}>Name of<br/>transferee</th>
//                         <th rowSpan={3} style={TH}>Balance shares<br/>(after transfer/<br/>transmission/<br/>forfeiture/<br/>redemption etc)</th>
//                         <th rowSpan={3} style={TH}>Remarks</th>
//                         <th rowSpan={3} style={TH}>Authentication<br/>/ signature</th>
//                       </tr>

//                       {/* ── Row 2: sub-headers for merged cols ── */}
//                       <tr style={{ background: "#f0f0f0" }}>
//                         <th style={TH}>From</th>
//                         <th style={TH}>To</th>
//                         <th style={TH}>Payable</th>
//                         <th style={TH}>Paid /<br/>Deemed to<br/>be paid</th>
//                         <th style={TH}>Due</th>
//                         <th style={TH}>From</th>
//                         <th style={TH}>To</th>
//                       </tr>

//                     </thead>

//                     {/* ── Body ── */}
//                     <tbody>
//                       {holdings.map((t, idx) => (
//                         <tr key={idx} style={{ background: idx % 2 === 0 ? "#fff" : "#fafafa" }}>
//                           <td style={TD}>{val(t.allotmentOrTransferNo)}</td>
//                           <td style={TD}>{fmt(t.dateOfAllotmentOrTransfer)}</td>
//                           <td style={TD}>{val(t.numberOfSharesAllottedOrTransferred)}</td>
//                           <td style={TD}>{val(t.distinctiveNumberFromTo?.from)}</td>
//                           <td style={TD}>{val(t.distinctiveNumberFromTo?.to)}</td>
//                           <td style={TD}>{val(t.folioOfTransferor)}</td>
//                           <td style={TD}>{val(t.nameOfTransferor)}</td>
//                           <td style={TD}>{fmt(t.dateOfIssueOrEndorsement)}</td>
//                           <td style={TD}>{val(t.certificateNo)}</td>
//                           <td style={TD}>{val(t.lockInPeriod)}</td>
//                           <td style={TD}>{cur(t.amount?.payable_Amount)}</td>
//                           <td style={TD}>{cur(t.amount?.paidOrDeemed_Amount)}</td>
//                           <td style={TD}>{cur(t.amount?.due_Amount)}</td>
//                           <td style={TD}>{val(t.considerationOtherThanCash)}</td>
//                           <td style={TD}>{fmt(t.dateOfTransferOrTransmission)}</td>
//                           <td style={TD}>{val(t.numberOfSharesTransferredOrTransmitted)}</td>
//                           <td style={TD}>{val(t.transferDistinctiveNoFromTo?.from)}</td>
//                           <td style={TD}>{val(t.transferDistinctiveNoFromTo?.to)}</td>
//                           <td style={TD}>{val(t.folioOfTransferee)}</td>
//                           <td style={TD}>{val(t.nameOfTransferee)}</td>
//                           <td style={TD}>{val(t.balanceSharesAfterTransaction)}</td>
//                           <td style={TD}>{val(t.remarks)}</td>
//                           <td style={TD}>{val(t.authenticationOrSignature)}</td>
//                         </tr>
//                       ))}

//                       {/* empty rows for manual fill */}
//                       {[...Array(3)].map((_, ei) => (
//                         <tr key={`empty-${ei}`} style={{ height: "20px" }}>
//                           {[...Array(23)].map((_, ci) => (
//                             <td key={ci} style={TD}>&nbsp;</td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────
//    SUB-COMPONENTS & SHARED STYLES
//    ───────────────────────────────────────────── */
// const PersonalRow = ({ label, value }) => (
//   <tr>
//     <td style={{ paddingRight: "6px", whiteSpace: "nowrap", verticalAlign: "top", width: "52%" }}>
//       {label}
//     </td>
//     <td style={{ verticalAlign: "top" }}>
//       {value !== null && value !== undefined && value !== "" ? String(value) : "-"}
//     </td>
//   </tr>
// );

// const TH = {
//   border: "1px solid #999",
//   padding: "2px 2px",
//   textAlign: "center",
//   verticalAlign: "middle",
//   fontWeight: "bold",
//   background: "inherit",
//   lineHeight: "1.25",
//   wordBreak: "break-word",
//   overflowWrap: "break-word",
// };

// const TD = {
//   border: "1px solid #999",
//   padding: "2px 2px",
//   textAlign: "left",
//   verticalAlign: "top",
//   wordBreak: "break-word",
//   overflowWrap: "break-word",
// };

// export default Mgt1RegisterViewer;

// import React, { useEffect, useRef, useState, useCallback } from "react";
// import html2pdf from "html2pdf.js";
// import { useSelector } from "react-redux";
// import { mgt1Api } from "../registerFormApi/Mgt1";
// import ShareSummaryTable from "./ShareSummaryTable";

// /* ═══════════════════════════════════════════════
//    PAGE-LEVEL STYLES (inline → PDF-safe)
//    ═══════════════════════════════════════════════ */
// const PAGE = {
//   width: "297mm",
//   minHeight: "210mm",
//   padding: "12mm 14mm",
//   fontFamily: "'Times New Roman', Times, serif",
//   fontSize: "9px",
//   color: "#000",
//   boxSizing: "border-box",
//   background: "#fff",
//   pageBreakInside: "avoid",
// };

// const LABEL_CELL = {
//   width: "210px",
//   minWidth: "210px",
//   verticalAlign: "top",
//   paddingRight: "6px",
//   whiteSpace: "nowrap",
// };
// const VALUE_CELL = { verticalAlign: "top", paddingLeft: "2px" };

// const TH = {
//   border: "1px solid #999",
//   padding: "2px",
//   textAlign: "center",
//   verticalAlign: "middle",
//   fontWeight: "bold",
//   fontSize: "9px",
//   wordBreak: "break-word",
//   whiteSpace: "normal"

// };
// const TD = {
//   border: "1px solid #999",
//   padding: "2px",
//   textAlign: "left",
//   verticalAlign: "top",
//   fontSize: "9px",
//   wordBreak: "break-word",
//   overflowWrap: "break-word",
//   whiteSpace: "normal" //
// };

// /* ═══════════════════════════════════════════════
//    EMPTY FORM STATE  (matches postman body exactly)
//    ═══════════════════════════════════════════════ */
// const emptyForm = () => ({
//   allotmentOrTransferNo: "",
//   dateOfAllotmentOrTransfer: "",
//   numberOfSharesAllottedOrTransferred: "",
//   distinctiveNumberFrom: "",
//   distinctiveNumberTo: "",
//   folioOfTransferor: "",
//   nameOfTransferor: "",
//   dateOfIssueOrEndorsement: "",
//   certificateNo: "",
//   lockInPeriod: "",
//   payableAmount: "",
//   paidOrDeemedAmount: "",
//   dueAmount: "",
//   considerationOtherThanCash: "",
//   dateOfTransferOrTransmission: "",
//   numberOfSharesTransferredOrTransmitted: "",
//   transferDistinctiveFrom: "",
//   transferDistinctiveTo: "",
//   folioOfTransferee: "",
//   nameOfTransferee: "",
//   balanceSharesAfterTransaction: "",
//   remarks: "",
//   authenticationOrSignature: "",
// });

// /* field meta: label → key, type  (order = form order) */
// const FIELDS = [
//   { label: "Allotment / Transfer No.", key: "allotmentOrTransferNo" },
//   {
//     label: "Date of Allotment / Transfer",
//     key: "dateOfAllotmentOrTransfer",
//     type: "date",
//   },
//   {
//     label: "No. of Shares Allotted / Transferred",
//     key: "numberOfSharesAllottedOrTransferred",
//     type: "number",
//   },
//   {
//     label: "Distinctive No. – From",
//     key: "distinctiveNumberFrom",
//     type: "number",
//   },
//   { label: "Distinctive No. – To", key: "distinctiveNumberTo", type: "number" },
//   { label: "Folio of Transferor", key: "folioOfTransferor" },
//   { label: "Name of Transferor", key: "nameOfTransferor" },
//   {
//     label: "Date of Issue / Endorsement",
//     key: "dateOfIssueOrEndorsement",
//     type: "date",
//   },
//   { label: "Certificate No.", key: "certificateNo" },
//   { label: "Lock-in Period", key: "lockInPeriod" },
//   { label: "Amount – Payable (₹)", key: "payableAmount", type: "number" },
//   {
//     label: "Amount – Paid / Deemed (₹)",
//     key: "paidOrDeemedAmount",
//     type: "number",
//   },
//   { label: "Amount – Due (₹)", key: "dueAmount", type: "number" },
//   { label: "Consideration Other Than Cash", key: "considerationOtherThanCash" },
//   {
//     label: "Date of Transfer / Transmission",
//     key: "dateOfTransferOrTransmission",
//     type: "date",
//   },
//   {
//     label: "No. of Shares Transferred / Forfeited",
//     key: "numberOfSharesTransferredOrTransmitted",
//     type: "number",
//   },
//   {
//     label: "Transfer Distinctive No. – From",
//     key: "transferDistinctiveFrom",
//     type: "number",
//   },
//   {
//     label: "Transfer Distinctive No. – To",
//     key: "transferDistinctiveTo",
//     type: "number",
//   },
//   { label: "Folio of Transferee", key: "folioOfTransferee" },
//   { label: "Name of Transferee", key: "nameOfTransferee" },
//   {
//     label: "Balance Shares After Transaction",
//     key: "balanceSharesAfterTransaction",
//     type: "number",
//   },
//   { label: "Remarks", key: "remarks" },
//   { label: "Authentication / Signature", key: "authenticationOrSignature" },
// ];

// /* ═══════════════════════════════════════════════
//    MAIN COMPONENT
//    ═══════════════════════════════════════════════ */
// const Mgt1RegisterViewer = ({ selectedClientData }) => {
//   const token = useSelector((state) => state.auth.access_token);

//   /* ── state ── */
//   const [registerData, setRegisterData] = useState([]);
//   const [summaryData, setSummaryData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [summaryLoading, setSummaryLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [activeTab, setActiveTab] = useState("summary"); // "summary" | "register"

//   /* modal */
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedMgt1Id, setSelectedMgt1Id] = useState(null);
//   const [selectedFolioNo, setSelectedFolioNo] = useState(null);
//   const [form, setForm] = useState(emptyForm());
//   const [submitting, setSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState(null);

//   const printRef = useRef(null);
//   const accountId = selectedClientData?.accountId || selectedClientData?.id;

//   /* ─── FETCH register (unchanged API) ─── */
//   const fetchRegisterData = useCallback(async () => {
//     if (!accountId || !token) return;
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await mgt1Api.fetchMgt1Register(accountId, token);
//       console.log("MGT-1 RESPONSE 👉", res);
//       setRegisterData(Array.isArray(res) ? res : []);
//     } catch (err) {
//       console.error("MGT-1 fetch error:", err);
//       setError("Failed to load MGT-1 data");
//     } finally {
//       setLoading(false);
//     }
//   }, [accountId, token]);

//   /* ─── FETCH share summary ─── */
//   const fetchSummary = useCallback(async () => {
//     if (!accountId || !token) return;
//     setSummaryLoading(true);
//     try {
//       const res = await mgt1Api.fetchMgt1ShareSummary(accountId, token);
//       console.log("MGT-1 SUMMARY 👉", res);
//       setSummaryData(Array.isArray(res) ? res : []);
//     } catch (err) {
//       console.error("Summary fetch error:", err);
//     } finally {
//       setSummaryLoading(false);
//     }
//   }, [accountId, token]);

//   useEffect(() => {
//     fetchRegisterData();
//     fetchSummary();
//   }, [fetchRegisterData, fetchSummary]);

//   /* ─── ADD NEW SHARE HOLDING (POST) ─── */
//   const handleSubmit = async () => {
//     if (!selectedMgt1Id) return;
//     setSubmitting(true);
//     setSubmitError(null);

//     /* build the exact payload the backend expects */
//     const payload = {
//       allotmentOrTransferNo: form.allotmentOrTransferNo || null,
//       dateOfAllotmentOrTransfer: form.dateOfAllotmentOrTransfer || null,
//       numberOfSharesAllottedOrTransferred: toNum(
//         form.numberOfSharesAllottedOrTransferred,
//       ),
//       distinctiveNumberFromTo: {
//         from: toNum(form.distinctiveNumberFrom),
//         to: toNum(form.distinctiveNumberTo),
//       },
//       folioOfTransferor: form.folioOfTransferor || null,
//       nameOfTransferor: form.nameOfTransferor || null,
//       dateOfIssueOrEndorsement: form.dateOfIssueOrEndorsement || null,
//       certificateNo: form.certificateNo || null,
//       lockInPeriod: form.lockInPeriod || null,
//       amount: {
//         payable_Amount: toNum(form.payableAmount),
//         paidOrDeemed_Amount: toNum(form.paidOrDeemedAmount),
//         due_Amount: toNum(form.dueAmount),
//       },
//       considerationOtherThanCash: form.considerationOtherThanCash || null,
//       dateOfTransferOrTransmission: form.dateOfTransferOrTransmission || null,
//       numberOfSharesTransferredOrTransmitted: toNum(
//         form.numberOfSharesTransferredOrTransmitted,
//       ),
//       transferDistinctiveNoFromTo: {
//         from: toNum(form.transferDistinctiveFrom),
//         to: toNum(form.transferDistinctiveTo),
//       },
//       folioOfTransferee: form.folioOfTransferee || null,
//       nameOfTransferee: form.nameOfTransferee || null,
//       balanceSharesAfterTransaction: toNum(form.balanceSharesAfterTransaction),
//       remarks: form.remarks || null,
//       authenticationOrSignature: form.authenticationOrSignature || null,
//     };

//     try {
//       const res = await mgt1Api.addNewShareHolding(
//         selectedMgt1Id,
//         payload,
//         token,
//       );
//       console.log("ADD share-holding RESPONSE 👉", res);
//       setModalOpen(false);
//       setForm(emptyForm());
//       /* refresh both lists */
//       await Promise.all([fetchRegisterData(), fetchSummary()]);
//     } catch (err) {
//       console.error("Add share-holding error:", err);
//       setSubmitError(
//         err?.message || "Failed to add share holding. Please try again.",
//       );
//     } finally {
//       setSubmitting(false);
//     }
//   };

// const handlePrintToPDF = async () => {
//   if (!printRef.current) return;

//   await html2pdf()
//     .set({
//       margin: 0,
//       filename: `MGT1_Register_${selectedClientData?.accountName || "Company"}.pdf`,
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: {
//         scale: 3,
//         scrollX: 0,
//         scrollY: 0,
//         windowWidth: 297 * 3.78, // A4 landscape px
//         windowHeight: 210 * 3.78,
//         useCORS: true,
//         background: true        // 🔥 keeps table shading
//       },
//       jsPDF: {
//         unit: "mm",
//         format: "a4",
//         orientation: "landscape"
//       },
//       pagebreak: {
//         mode: ["css"]           // 🔥 safer for tables
//       }
//     })
//     .from(printRef.current)
//     .save();
// };

//   /* ─── HELPERS ─── */
//   const fmt = (d) => {
//     if (!d) return "-";
//     try {
//       return new Date(d).toLocaleDateString("en-GB", {
//         day: "2-digit",
//         month: "2-digit",
//         year: "numeric",
//       });
//     } catch {
//       return "-";
//     }
//   };
//   const cur = (v) =>
//     v || v === 0 ? `₹${Number(v).toLocaleString("en-IN")}` : "-";
//   const val = (v) =>
//     v !== null && v !== undefined && v !== "" ? String(v) : "-";
//   const toNum = (v) =>
//     v === "" || v === null || v === undefined ? null : Number(v);

//   /* ─── OPEN modal for a specific folio ─── */
//   const openModal = (member) => {
//     setSelectedMgt1Id(member.id); // the mgt1Id for the URL param
//     setSelectedFolioNo(member.folio_no);
//     setForm(emptyForm());
//     setSubmitError(null);
//     setModalOpen(true);
//   };

//   /* ═══ EARLY RETURNS ═══ */
//   if (!selectedClientData)
//     return <p className="text-center text-gray-500 mt-10">Select an account</p>;

//   /* ═══════════════════════════════════════════════
//      RENDER
//      ═══════════════════════════════════════════════ */
//   return (
//     <div className="bg-gray-100 min-h-screen p-4">
//       {/* ───── TOOLBAR ───── */}
//       <div className="flex flex-wrap justify-between items-center mb-4 gap-2">
//         <h2 className="font-bold text-lg text-gray-800">
//           MGT-1 Register of Members
//         </h2>
//         <div className="flex gap-2 flex-wrap">
//           <button
//             onClick={() => {
//               fetchRegisterData();
//               fetchSummary();
//             }}
//             className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded text-sm font-semibold"
//           >
//             🔄 Reload
//           </button>
//           <button
//             onClick={handlePrintToPDF}
//             disabled={registerData.length === 0}
//             className="bg-green-600 hover:bg-green-700 disabled:opacity-40 text-white px-4 py-1.5 rounded text-sm font-semibold"
//           >
//             📄 Export PDF
//           </button>
//         </div>
//       </div>

//       {/* ───── TAB SWITCHER ───── */}
//       <div className="flex border-b border-gray-300 mb-4">
//         <button
//           onClick={() => setActiveTab("summary")}
//           className={`px-5 py-2 text-sm font-semibold transition-colors
//             ${
//               activeTab === "summary"
//                 ? "border-b-2 border-blue-600 text-blue-700 bg-white"
//                 : "text-gray-500 hover:text-gray-700"
//             }`}
//         >
//           📊 Share Summary
//         </button>
//         <button
//           onClick={() => setActiveTab("register")}
//           className={`px-5 py-2 text-sm font-semibold transition-colors
//             ${
//               activeTab === "register"
//                 ? "border-b-2 border-blue-600 text-blue-700 bg-white"
//                 : "text-gray-500 hover:text-gray-700"
//             }`}
//         >
//           📋 MGT-1 Register
//         </button>
//       </div>

//       {/* ══════════════════════════════════════════
//           TAB 1 → SHARE SUMMARY
//           ══════════════════════════════════════════ */}
//       {activeTab === "summary" && (
//         // <div className="bg-white rounded-lg shadow p-2">
//         //   <div className="flex justify-between items-center mb-2">
//         //     <h3 className="font-semibold text-gray-700 text-base">Share Summary – All Folios</h3>
//         //     {/* total row */}
//         //     {summaryData.length > 0 && (
//         //       <span className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
//         //         Total Shares: <strong>{summaryData.reduce((s, r) => s + (r.numberOfShares || 0), 0).toLocaleString("en-IN")}</strong>
//         //       </span>
//         //     )}
//         //   </div>

//         //   {summaryLoading ? (
//         //     <p className="text-center text-gray-400 py-8">Loading summary…</p>
//         //   ) : summaryData.length === 0 ? (
//         //     <p className="text-center text-gray-400 py-8">No share summary data available.</p>
//         //   ) : (
//         //     <div className="overflow-x-auto">
//         //       <table className="w-full text-sm border-collapse">
//         //         <thead>
//         //           <tr className="bg-blue-600 text-white">
//         //             <th className="border border-blue-500 px-4 py-2.5 text-left font-semibold">#</th>
//         //             <th className="border border-blue-500 px-4 py-2.5 text-left font-semibold">Folio No.</th>
//         //             <th className="border border-blue-500 px-4 py-2.5 text-left font-semibold">Member Name</th>
//         //             <th className="border border-blue-500 px-4 py-2.5 text-left font-semibold">Joint Holder Name</th>
//         //             <th className="border border-blue-500 px-4 py-2.5 text-right font-semibold">No. of Shares</th>
//         //             <th className="border border-blue-500 px-4 py-2.5 text-center font-semibold">Action</th>
//         //           </tr>
//         //         </thead>
//         //         <tbody>
//         //           {summaryData.map((row, idx) => {
//         //             /* find matching mgt1 record (by folio) to get the id for the API */
//         //             const mgt1Match = registerData.find(r => String(r.folio_no) === String(row.folioNo));
//         //             return (
//         //               <tr key={idx} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
//         //                 <td className="border border-gray-200 px-4 py-2 text-gray-500">{idx + 1}</td>
//         //                 <td className="border border-gray-200 px-4 py-2 font-semibold text-gray-800">{val(row.folioNo)}</td>
//         //                 <td className="border border-gray-200 px-4 py-2 text-gray-700">{val(row.memberName)}</td>
//         //                 <td className="border border-gray-200 px-4 py-2 text-gray-600">{val(row.jointHolderName)}</td>
//         //                 <td className="border border-gray-200 px-4 py-2 text-right font-medium text-gray-800">
//         //                   {row.numberOfShares != null ? Number(row.numberOfShares).toLocaleString("en-IN") : "-"}
//         //                 </td>
//         //                 <td className="border border-gray-200 px-4 py-2 text-center">
//         //                   <button
//         //                     onClick={() => mgt1Match && openModal(mgt1Match)}
//         //                     disabled={!mgt1Match}
//         //                     className="bg-indigo-600 hover:bg-indigo-700 disabled:opacity-40 disabled:cursor-not-allowed text-white text-xs font-semibold px-3 py-1.5 rounded transition-colors"
//         //                   >
//         //                     + Add Share Holding
//         //                   </button>
//         //                 </td>
//         //               </tr>
//         //             );
//         //           })}
//         //         </tbody>
//         //       </table>
//         //     </div>
//         //   )}
//         // </div>

//         <div className="bg-white rounded-lg shadow p-2">
//           <ShareSummaryTable
//             summaryData={summaryData}
//             registerData={registerData}
//             showAction={true}
//             onAddShare={openModal}
//           />
//         </div>
//       )}

//       {/* ══════════════════════════════════════════
//           TAB 2 → MGT-1 REGISTER (per-folio pages)
//           ══════════════════════════════════════════ */}
//       {activeTab === "register" && (
//         <>
//           {loading ? (
//             <p className="text-center text-gray-400 py-10">Loading MGT-1…</p>
//           ) : error ? (
//             <p className="text-center text-red-600 py-10">{error}</p>
//           ) : registerData.length === 0 ? (
//             <p className="text-center text-gray-400 py-10">
//               No MGT-1 data found
//             </p>
//           ) : (
//             <div ref={printRef}>
//               {/* ───────── PAGE 1 : SHARE SUMMARY ONLY ───────── */}
//               <div style={PAGE} className="shadow-md mx-auto ">
//                 <ShareSummaryTable
//                   summaryData={summaryData}
//                   registerData={registerData}
//                   showAction={false} // no buttons in PDF
//                 />
//               </div>
//               {registerData.map((member, i) => {
//                 const pd = member.personalDetails || {};
//                 const md = member.memberMinorDetails || {};
//                 const ms = md.memberShipDetails || {};
//                 const addr = member.registeredOfficeAddress || {};
//                 const holdings = member.mgt1ShareHolding || [];

//                 return (
//                   <div key={i} style={PAGE} className="shadow-md mx-auto ">
//                     {/* ── HEADER ── */}
//                     <div style={{ textAlign: "center", marginBottom: "6px" }}>
//                       <div style={{ fontSize: "13px", fontWeight: "bold" }}>
//                         Form No. MGT - 1
//                       </div>
//                       <div style={{ fontSize: "12px", fontWeight: "bold" }}>
//                         Register of members
//                       </div>
//                       <div style={{ fontSize: "10px", marginTop: "2px" }}>
//                         [Pursuant to section 88 (1)(a) of the Companies Act,
//                         2013 and rule 3(1) of the Companies (Management and
//                         Administration) Rules, 2014]
//                       </div>
//                     </div>

//                     {/* ── COMPANY INFO ── */}
//                     <table
//                       style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         fontSize: "8px",
//                          tableLayout: "fixed"
//                       }}
//                     >
//                       <tbody>
//                         <tr>
//                           <td style={{ ...LABEL_CELL, fontWeight: "bold" }}>
//                             Name of the Company:
//                           </td>
//                           <td style={VALUE_CELL}>{val(member.companyName)}</td>
//                         </tr>
//                         <tr>
//                           <td style={LABEL_CELL}>Registered office address:</td>
//                           <td style={VALUE_CELL}>
//                             {addr.address
//                               ? `${addr.address}, ${addr.city || ""}, ${addr.state || ""}, ${addr.pincode || ""}`
//                               : "-"}
//                           </td>
//                         </tr>
//                         <tr>
//                           <td
//                             colSpan={2}
//                             style={{
//                               fontSize: "9px",
//                               fontStyle: "italic",
//                               color: "#555",
//                               paddingBottom: "3px",
//                             }}
//                           >
//                             TO BE MAINTAINED SEPARATELY FOR EACH CLASS OF SHARES
//                           </td>
//                         </tr>
//                         <tr>
//                           <td style={LABEL_CELL}>Class of shares:</td>
//                           <td style={VALUE_CELL}>{val(member.shareClass)}</td>
//                         </tr>
//                         <tr>
//                           <td style={LABEL_CELL}>
//                             Nominal value per share (in Rs.):
//                           </td>
//                           <td style={VALUE_CELL}>
//                             {val(member.nominalValuePerShare)}
//                           </td>
//                         </tr>
//                         <tr>
//                           <td style={LABEL_CELL}>Total shares held:</td>
//                           <td style={VALUE_CELL}>
//                             {val(member.totalSharesHeld)}
//                           </td>
//                         </tr>
//                         <tr>
//                           <td style={{ ...LABEL_CELL, fontWeight: "bold" }}>
//                             FOLIO NO.
//                           </td>
//                           <td style={{ ...VALUE_CELL, fontWeight: "bold" }}>
//                             {val(member.folio_no)}
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     {/* ── PERSONAL + MINOR (2-col) ── */}
//                     <div
//                       style={{
//                         display: "flex",
//                         gap: "18px",
//                         marginTop: "8px",
//                         fontSize: "9px",
//                       }}
//                     >
//                       <div style={{ flex: 1 }}>
//                         <div
//                           style={{
//                             fontWeight: "bold",
//                             marginBottom: "3px",
//                             borderBottom: "1px solid #000",
//                             paddingBottom: "2px",
//                           }}
//                         >
//                           Personal details
//                         </div>
//                         <table
//                           style={{ width: "100%", borderCollapse: "collapse" }}
//                         >
//                           <tbody>
//                             <PersonalRow
//                               label="Name of the member"
//                               value={pd.memberName}
//                             />
//                             <PersonalRow
//                               label="Name of joint holders, if any"
//                               value={pd.jointHoldersName}
//                             />
//                             <PersonalRow
//                               label="Address / Registered address (in case of body corporate):"
//                               value={pd.addressOrRegisteredAddress}
//                             />
//                             <PersonalRow label="E-mail Id" value={pd.emailId} />
//                             <PersonalRow
//                               label="CIN / Registration No."
//                               value={pd.cinOrRegistrationNo}
//                             />
//                             <PersonalRow
//                               label="Unique Identification No"
//                               value={pd.uniqueIdentificationNo}
//                             />
//                             <PersonalRow
//                               label="Father's / Mother's / Spouse's name"
//                               value={pd.parentOrSpouseName}
//                             />
//                             <PersonalRow label="Status" value={pd.status} />
//                             <PersonalRow
//                               label="Occupation"
//                               value={pd.occupation}
//                             />
//                             <PersonalRow label="PAN" value={pd.panNo} />
//                             <PersonalRow
//                               label="Nationality"
//                               value={pd.nationality}
//                             />
//                           </tbody>
//                         </table>
//                       </div>
//                       <div style={{ flex: 1 }}>
//                         <div
//                           style={{
//                             fontWeight: "bold",
//                             marginBottom: "3px",
//                             borderBottom: "1px solid #000",
//                             paddingBottom: "2px",
//                           }}
//                         >
//                           In case member is a minor,
//                         </div>
//                         <table
//                           style={{ width: "100%", borderCollapse: "collapse" }}
//                         >
//                           <tbody>
//                             <PersonalRow
//                               label="Name of Guardian"
//                               value={md.guardianName}
//                             />
//                             <PersonalRow
//                               label="Date of birth of minor"
//                               value={fmt(md.dateOfBirthOfMinor)}
//                             />
//                             <PersonalRow
//                               label="Date of becoming member"
//                               value={fmt(md.dateOfBecomingMember)}
//                             />
//                             <PersonalRow
//                               label="Details of membership"
//                               value={null}
//                             />
//                             <PersonalRow
//                               label="Date of declaration under section 89, if applicable"
//                               value={fmt(ms.declarationDateUnderSection89)}
//                             />
//                             <PersonalRow
//                               label="Name and address of beneficial owner"
//                               value={ms.beneficialOwnerNameAndAddress}
//                             />
//                             <PersonalRow
//                               label="Date of receipt of nomination, if applicable"
//                               value={fmt(ms.nominationReceiptDate)}
//                             />
//                             <PersonalRow
//                               label="Name and address of nominee"
//                               value={ms.nomineeNameAndAddress}
//                             />
//                             <PersonalRow
//                               label="No. of shares kept in abeyance, if applicable"
//                               value={ms.sharesKeptInAbeyance}
//                             />
//                             <PersonalRow
//                               label="Record of lien on shares, if applicable"
//                               value={ms.lienOnShares}
//                             />
//                             <PersonalRow
//                               label="Date of cessation of membership"
//                               value={fmt(ms.dateOfCessationOfMembership)}
//                             />
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>

//                     {/* ── INSTRUCTIONS ── */}
//                     <div style={{ marginTop: "10px", fontSize: "8px" }}>
//                       <div style={{ fontWeight: "bold", marginBottom: "2px" }}>
//                         Instructions
//                       </div>
//                       <div>
//                         Particulars of dividend mandates, power of attorney and
//                         other instructions, if any:
//                       </div>
//                       <div>Instruction for sending notices etc., if any:</div>
//                     </div>

//                     {/* ── SHARE HOLDING TABLE (19-col) ── */}
//                     <div style={{ marginTop: "8px" }}>
//                       <div
//                         style={{
//                           fontWeight: "bold",
//                           marginBottom: "4px",
//                           fontSize: "9px",
//                           tableLayout:"fixed"
//                         }}
//                       >
//                         Details of share holding
//                       </div>
//                       <div >
//                         <table
//                           style={{
//                             width: "100%",
//                             borderCollapse: "collapse",
//                               fontSize: "6.5px",
//                             tableLayout: "fixed",
//                           }}
//                         >
//                           <colgroup>
//                             <col style={{ width: "5.2%" }} />
//                             <col style={{ width: "4.8%" }} />
//                             <col style={{ width: "4.2%" }} />
//                             <col style={{ width: "3.8%" }} />
//                             <col style={{ width: "3.8%" }} />
//                             <col style={{ width: "3.8%" }} />
//                             <col style={{ width: "5.5%" }} />
//                             <col style={{ width: "5.0%" }} />
//                             <col style={{ width: "4.0%" }} />
//                             <col style={{ width: "4.0%" }} />
//                             <col style={{ width: "4.2%" }} />
//                             <col style={{ width: "4.8%" }} />
//                             <col style={{ width: "3.5%" }} />
//                             <col style={{ width: "5.2%" }} />
//                             <col style={{ width: "4.8%" }} />
//                             <col style={{ width: "4.2%" }} />
//                             <col style={{ width: "3.5%" }} />
//                             <col style={{ width: "3.5%" }} />
//                             <col style={{ width: "3.8%" }} />
//                             <col style={{ width: "5.0%" }} />
//                             <col style={{ width: "5.2%" }} />
//                             <col style={{ width: "3.8%" }} />
//                             <col style={{ width: "4.5%" }} />
//                           </colgroup>
//                           <thead>
//                             <tr style={{ background: "#f0f0f0" }}>
//                               <th rowSpan={3} style={TH}>
//                                 Allotment No./
//                                 <br />
//                                 Transfer No.
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Date of
//                                 <br />
//                                 allotment/
//                                 <br />
//                                 transfer
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 No. of shares
//                                 <br />
//                                 allotted/
//                                 <br />
//                                 transferred
//                               </th>
//                               <th colSpan={2} style={TH}>
//                                 Distinctive numbers
//                                 <br />
//                                 (both inclusive)
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Folio of
//                                 <br />
//                                 transferor
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Name of the
//                                 <br />
//                                 transferor
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Date of issue or
//                                 <br />
//                                 endorsement
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Certificate
//                                 <br />
//                                 No.
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Lock in
//                                 <br />
//                                 period
//                               </th>
//                               <th colSpan={3} style={TH}>
//                                 Amount (Rs)
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Consideration
//                                 <br />
//                                 other than cash
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Date of
//                                 <br />
//                                 transfer/
//                                 <br />
//                                 transmission
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 No. of shares
//                                 <br />
//                                 transferred/
//                                 <br />
//                                 forfeited
//                               </th>
//                               <th colSpan={2} style={TH}>
//                                 Distinctive numbers
//                                 <br />
//                                 (both inclusive)
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Folio of
//                                 <br />
//                                 transferee
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Name of
//                                 <br />
//                                 transferee
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Balance shares
//                                 <br />
//                                 (after transfer)
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Remarks
//                               </th>
//                               <th rowSpan={3} style={TH}>
//                                 Auth /<br />
//                                 Signature
//                               </th>
//                             </tr>
//                             <tr style={{ background: "#f0f0f0" }}>
//                               <th style={TH}>From</th>
//                               <th style={TH}>To</th>
//                               <th style={TH}>Payable</th>
//                               <th style={TH}>Paid /Deemed</th>
//                               <th style={TH}>Due</th>
//                               <th style={TH}>From</th>
//                               <th style={TH}>To</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {holdings.map((t, idx) => (
//                               <tr
//                                 key={idx}
//                                 style={{
//                                   background:
//                                     idx % 2 === 0 ? "#fff" : "#fafafa",
//                                 }}
//                               >
//                                 <td style={TD}>
//                                   {val(t.allotmentOrTransferNo)}
//                                 </td>
//                                 <td style={TD}>
//                                   {fmt(t.dateOfAllotmentOrTransfer)}
//                                 </td>
//                                 <td style={TD}>
//                                   {val(t.numberOfSharesAllottedOrTransferred)}
//                                 </td>
//                                 <td style={TD}>
//                                   {val(t.distinctiveNumberFromTo?.from)}
//                                 </td>
//                                 <td style={TD}>
//                                   {val(t.distinctiveNumberFromTo?.to)}
//                                 </td>
//                                 <td style={TD}>{val(t.folioOfTransferor)}</td>
//                                 <td style={TD}>{val(t.nameOfTransferor)}</td>
//                                 <td style={TD}>
//                                   {fmt(t.dateOfIssueOrEndorsement)}
//                                 </td>
//                                 <td style={TD}>{val(t.certificateNo)}</td>
//                                 <td style={TD}>{val(t.lockInPeriod)}</td>
//                                 <td style={TD}>
//                                   {cur(t.amount?.payable_Amount)}
//                                 </td>
//                                 <td style={TD}>
//                                   {cur(t.amount?.paidOrDeemed_Amount)}
//                                 </td>
//                                 <td style={TD}>{cur(t.amount?.due_Amount)}</td>
//                                 <td style={TD}>
//                                   {val(t.considerationOtherThanCash)}
//                                 </td>
//                                 <td style={TD}>
//                                   {fmt(t.dateOfTransferOrTransmission)}
//                                 </td>
//                                 <td style={TD}>
//                                   {val(
//                                     t.numberOfSharesTransferredOrTransmitted,
//                                   )}
//                                 </td>
//                                 <td style={TD}>
//                                   {val(t.transferDistinctiveNoFromTo?.from)}
//                                 </td>
//                                 <td style={TD}>
//                                   {val(t.transferDistinctiveNoFromTo?.to)}
//                                 </td>
//                                 <td style={TD}>{val(t.folioOfTransferee)}</td>
//                                 <td style={TD}>{val(t.nameOfTransferee)}</td>
//                                 <td style={TD}>
//                                   {val(t.balanceSharesAfterTransaction)}
//                                 </td>
//                                 <td style={TD}>{val(t.remarks)}</td>
//                                 <td style={TD}>
//                                   {val(t.authenticationOrSignature)}
//                                 </td>
//                               </tr>
//                             ))}
//                             {[...Array(3)].map((_, ei) => (
//                               <tr key={`e-${ei}`} style={{ height: "20px" }}>
//                                 {[...Array(23)].map((_, ci) => (
//                                   <td key={ci} style={TD}>
//                                     &nbsp;
//                                   </td>
//                                 ))}
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </>
//       )}

//       {/* ══════════════════════════════════════════
//           MODAL – Add New Share Holding
//           ══════════════════════════════════════════ */}
//       {modalOpen && (
//         <div
//           className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50"
//           style={{ paddingTop: "40px" }}
//           onClick={(e) => {
//             if (e.target === e.currentTarget) setModalOpen(false);
//           }}
//         >
//           <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto relative">
//             {/* header */}
//             <div className="sticky top-0 bg-indigo-700 text-white px-5 py-3 flex justify-between items-center rounded-t-xl z-10">
//               <div>
//                 <h3 className="font-bold text-base">+ Add New Share Holding</h3>
//                 <p className="text-indigo-200 text-xs">
//                   Folio No: <strong>{selectedFolioNo}</strong>
//                 </p>
//               </div>
//               <button
//                 onClick={() => setModalOpen(false)}
//                 className="text-indigo-200 hover:text-white text-xl leading-none"
//               >
//                 &times;
//               </button>
//             </div>

//             {/* body */}
//             <div className="p-5">
//               {submitError && (
//                 <div className="bg-red-50 border border-red-300 text-red-700 text-xs rounded px-3 py-2 mb-4">
//                   ⚠️ {submitError}
//                 </div>
//               )}

//               {/* 2-col grid of inputs */}
//               <div className="grid grid-cols-2 gap-x-5 gap-y-3">
//                 {FIELDS.map((f) => (
//                   <div key={f.key}>
//                     <label className="block text-xs font-semibold text-gray-600 mb-0.5">
//                       {f.label}
//                     </label>
//                     <input
//                       type={f.type || "text"}
//                       value={form[f.key]}
//                       onChange={(e) =>
//                         setForm((prev) => ({
//                           ...prev,
//                           [f.key]: e.target.value,
//                         }))
//                       }
//                       disabled={submitting}
//                       className="w-full border border-gray-300 rounded px-2.5 py-1.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-400 disabled:bg-gray-100"
//                       placeholder={
//                         f.type === "date"
//                           ? "yyyy-mm-dd"
//                           : f.type === "number"
//                             ? "0"
//                             : "—"
//                       }
//                     />
//                   </div>
//                 ))}
//               </div>

//               {/* action buttons */}
//               <div className="flex justify-end gap-3 mt-6">
//                 <button
//                   onClick={() => setModalOpen(false)}
//                   disabled={submitting}
//                   className="px-4 py-2 border border-gray-300 rounded text-sm text-gray-600 hover:bg-gray-50 disabled:opacity-50"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleSubmit}
//                   disabled={submitting}
//                   className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 text-white text-sm font-semibold rounded flex items-center gap-2"
//                 >
//                   {submitting && (
//                     <span className="inline-block w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                   )}
//                   {submitting ? "Saving…" : "💾 Save"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// /* ═══════════════════════════════════════════════
//    TINY SUB-COMPONENTS
//    ═══════════════════════════════════════════════ */
// const PersonalRow = ({ label, value }) => (
//   <tr>
//     <td
//       style={{
//         paddingRight: "6px",
//         whiteSpace: "nowrap",
//         verticalAlign: "top",
//         width: "52%",
//       }}
//     >
//       {label}
//     </td>
//     <td style={{ verticalAlign: "top" }}>
//       {value !== null && value !== undefined && value !== ""
//         ? String(value)
//         : "-"}
//     </td>
//   </tr>
// );

// export default Mgt1RegisterViewer;

import React, { useEffect, useRef, useState, useCallback } from "react";
import html2pdf from "html2pdf.js";
import { useSelector } from "react-redux";
import { mgt1Api } from "../registerFormApi/Mgt1";
import ShareSummaryTable from "./ShareSummaryTable";

/* ═══════════════════════════════════════════════
   READABLE PDF STYLES - Portrait A4, proper sizing
   ═══════════════════════════════════════════════ */
const PAGE = {
  width: "210mm",
  minHeight: "297mm",
  padding: "8mm 6mm",
  fontFamily: "'Arial', sans-serif",
  fontSize: "8px",
  color: "#000",
  boxSizing: "border-box",
  background: "#fff",
};

const LABEL_CELL = {
  width: "180px",
  verticalAlign: "top",
  paddingRight: "4px",
  fontSize: "7px",
};

const VALUE_CELL = {
  verticalAlign: "top",
  paddingLeft: "2px",
  fontSize: "7px",
};

const TH = {
  border: "1px solid #666",
  paddingLeft: "6px",
  paddingBottom: "6px",
  textAlign: "center",
  verticalAlign: "middle",
  fontWeight: "bold",
  fontSize: "8px",
  /* 🔥 THIS IS THE KEY */
  whiteSpace: "normal", // allow line breaks
  wordBreak: "break-word", // break long words
  overflowWrap: "break-word",
};

const TD = {
  border: "1px solid #666",
  paddingLeft: "6px",
  textAlign: "left",
  paddingBottom: "6px",
  // verticalAlign: "top",
  fontSize: "8px",

  // whiteSpace: "normal",
  // wordBreak: "break-word"
};

const emptyForm = () => ({
  allotmentOrTransferNo: "",
  dateOfAllotmentOrTransfer: "",
  numberOfSharesAllottedOrTransferred: "",
  distinctiveNumberFrom: "",
  distinctiveNumberTo: "",
  folioOfTransferor: "",
  nameOfTransferor: "",
  dateOfIssueOrEndorsement: "",
  certificateNo: "",
  lockInPeriod: "",
  payableAmount: "",
  paidOrDeemedAmount: "",
  dueAmount: "",
  considerationOtherThanCash: "",
  dateOfTransferOrTransmission: "",
  numberOfSharesTransferredOrTransmitted: "",
  transferDistinctiveFrom: "",
  transferDistinctiveTo: "",
  folioOfTransferee: "",
  nameOfTransferee: "",
  balanceSharesAfterTransaction: "",
  remarks: "",
  authenticationOrSignature: "",
});

const FIELDS = [
  { label: "Allotment / Transfer No.", key: "allotmentOrTransferNo" },
  {
    label: "Date of Allotment / Transfer",
    key: "dateOfAllotmentOrTransfer",
    type: "date",
  },
  {
    label: "No. of Shares Allotted / Transferred",
    key: "numberOfSharesAllottedOrTransferred",
    type: "number",
  },
  {
    label: "Distinctive No. – From",
    key: "distinctiveNumberFrom",
    type: "number",
  },
  { label: "Distinctive No. – To", key: "distinctiveNumberTo", type: "number" },
  { label: "Folio of Transferor", key: "folioOfTransferor" },
  { label: "Name of Transferor", key: "nameOfTransferor" },
  {
    label: "Date of Issue / Endorsement",
    key: "dateOfIssueOrEndorsement",
    type: "date",
  },
  { label: "Certificate No.", key: "certificateNo" },
  { label: "Lock-in Period", key: "lockInPeriod" },
  { label: "Amount – Payable (₹)", key: "payableAmount", type: "number" },
  {
    label: "Amount – Paid / Deemed (₹)",
    key: "paidOrDeemedAmount",
    type: "number",
  },
  { label: "Amount – Due (₹)", key: "dueAmount", type: "number" },
  { label: "Consideration Other Than Cash", key: "considerationOtherThanCash" },
  {
    label: "Date of Transfer / Transmission",
    key: "dateOfTransferOrTransmission",
    type: "date",
  },
  {
    label: "No. of Shares Transferred / Forfeited",
    key: "numberOfSharesTransferredOrTransmitted",
    type: "number",
  },
  {
    label: "Transfer Distinctive No. – From",
    key: "transferDistinctiveFrom",
    type: "number",
  },
  {
    label: "Transfer Distinctive No. – To",
    key: "transferDistinctiveTo",
    type: "number",
  },
  { label: "Folio of Transferee", key: "folioOfTransferee" },
  { label: "Name of Transferee", key: "nameOfTransferee" },
  {
    label: "Balance Shares After Transaction",
    key: "balanceSharesAfterTransaction",
    type: "number",
  },
  { label: "Remarks", key: "remarks" },
  { label: "Authentication / Signature", key: "authenticationOrSignature" },
];

const Mgt1RegisterViewer = ({ selectedClientData }) => {
  const token = useSelector((state) => state.auth.access_token);

  const [registerData, setRegisterData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("summary");

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMgt1Id, setSelectedMgt1Id] = useState(null);
  const [selectedFolioNo, setSelectedFolioNo] = useState(null);
  const [form, setForm] = useState(emptyForm());
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const printRef = useRef(null);
  const accountId = selectedClientData?.accountId || selectedClientData?.id;

  const fetchRegisterData = useCallback(async () => {
    if (!accountId || !token) return;
    setLoading(true);
    setError(null);
    try {
      const res = await mgt1Api.fetchMgt1Register(accountId, token);
      setRegisterData(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error("MGT-1 fetch error:", err);
      setError("Not data available of MGT-1");
    } finally {
      setLoading(false);
    }
  }, [accountId, token]);

  const fetchSummary = useCallback(async () => {
    if (!accountId || !token) return;
    setSummaryLoading(true);
    try {
      const res = await mgt1Api.fetchMgt1ShareSummary(accountId, token);
      setSummaryData(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error("Summary fetch error:", err);
    } finally {
      setSummaryLoading(false);
    }
  }, [accountId, token]);

  useEffect(() => {
    fetchRegisterData();
    fetchSummary();
  }, [fetchRegisterData, fetchSummary]);

  const handleSubmit = async () => {
    if (!selectedMgt1Id) return;
    setSubmitting(true);
    setSubmitError(null);

    const payload = {
      allotmentOrTransferNo: form.allotmentOrTransferNo || null,
      dateOfAllotmentOrTransfer: form.dateOfAllotmentOrTransfer || null,
      numberOfSharesAllottedOrTransferred: toNum(
        form.numberOfSharesAllottedOrTransferred,
      ),
      distinctiveNumberFromTo: {
        from: toNum(form.distinctiveNumberFrom),
        to: toNum(form.distinctiveNumberTo),
      },
      folioOfTransferor: form.folioOfTransferor || null,
      nameOfTransferor: form.nameOfTransferor || null,
      dateOfIssueOrEndorsement: form.dateOfIssueOrEndorsement || null,
      certificateNo: form.certificateNo || null,
      lockInPeriod: form.lockInPeriod || null,
      amount: {
        payable_Amount: toNum(form.payableAmount),
        paidOrDeemed_Amount: toNum(form.paidOrDeemedAmount),
        due_Amount: toNum(form.dueAmount),
      },
      considerationOtherThanCash: form.considerationOtherThanCash || null,
      dateOfTransferOrTransmission: form.dateOfTransferOrTransmission || null,
      numberOfSharesTransferredOrTransmitted: toNum(
        form.numberOfSharesTransferredOrTransmitted,
      ),
      transferDistinctiveNoFromTo: {
        from: toNum(form.transferDistinctiveFrom),
        to: toNum(form.transferDistinctiveTo),
      },
      folioOfTransferee: form.folioOfTransferee || null,
      nameOfTransferee: form.nameOfTransferee || null,
      balanceSharesAfterTransaction: toNum(form.balanceSharesAfterTransaction),
      remarks: form.remarks || null,
      authenticationOrSignature: form.authenticationOrSignature || null,
    };

    try {
      const res = await mgt1Api.addNewShareHolding(
        selectedMgt1Id,
        payload,
        token,
      );
      setModalOpen(false);
      setForm(emptyForm());
      await Promise.all([fetchRegisterData(), fetchSummary()]);
    } catch (err) {
      console.error("Add share-holding error:", err);
      setSubmitError(
        err?.message || "Failed to add share holding. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handlePrintToPDF = async () => {
    if (!printRef.current) return;

    await html2pdf()
      .set({
        margin: [0, 0, 0, 0],
        filename: `MGT1_Register_${selectedClientData?.accountName || "Company"}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: {
          scale: 3,
          scrollX: 0,
          scrollY: 0,
          useCORS: true,
          logging: false,
          windowWidth: 794, // A4 portrait width in pixels
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
          compress: true,
        },
        pagebreak: {
          mode: ["avoid-all", "css"],
        },
      })
      .from(printRef.current)
      .save();
  };

  const fmt = (d) => {
    if (!d) return "-";
    try {
      return new Date(d).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch {
      return "-";
    }
  };
  const cur = (v) =>
    v || v === 0 ? `₹${Number(v).toLocaleString("en-IN")}` : "-";
  const val = (v) =>
    v !== null && v !== undefined && v !== "" ? String(v) : "-";
  const toNum = (v) =>
    v === "" || v === null || v === undefined ? null : Number(v);

  const openModal = (member) => {
    setSelectedMgt1Id(member.id);
    setSelectedFolioNo(member.folio_no);
    setForm(emptyForm());
    setSubmitError(null);
    setModalOpen(true);
  };

  if (!selectedClientData)
    return <p className="text-center text-gray-500 mt-10">Select an account</p>;

  return (
    <div className="bg-gray-100 min-h-screen p-1">
      <div className="flex flex-wrap justify-between items-center  ">
        <div className="font-bold text-lg text-gray-800">
          MGT-1 Register of Members
        </div>
        {/* <div className="flex gap-2 flex-wrap">
          <button
            onClick={() => {
              fetchRegisterData();
              fetchSummary();
            }}
            className="bg-primary text-white px-4 py-1.5 rounded text-sm font-semibold"
          >
            🔄 Reload
          </button>
          <button
            onClick={handlePrintToPDF}
            disabled={registerData.length === 0}
            className="bg-primary disabled:opacity-40 text-white px-4 py-1.5 rounded text-sm font-semibold"
          >
            📄 Export PDF
          </button>
        </div> */}
      </div>

      <div className="flex border-b border-gray-300 mb-1">
        <button
          onClick={() => setActiveTab("summary")}
          className={`px-3 py-1 rounded-lg text-sm font-semibold transition-colors ${activeTab === "summary" ? "border-b-2 border-blue-600 text-blue-700 bg-white" : "text-gray-500 hover:text-gray-700"}`}
        >
          📊 Share Summary
        </button>
        <button
          onClick={() => setActiveTab("register")}
          className={`px-3 py-1  rounded-lg  text-sm font-semibold transition-colors ${activeTab === "register" ? "border-b-2 border-blue-600 text-blue-700 bg-white" : "text-gray-500 hover:text-gray-700"}`}
        >
          📋 MGT-1 Register
        </button>
      </div>

      {activeTab === "summary" && (
        <ShareSummaryTable
          summaryData={summaryData}
          registerData={registerData}
          showAction={true}
          onAddShare={openModal}
        />
      )}

      {activeTab === "register" && (
        <>
               <div className="flex gap-2 mb-3 justify-end items-end">
                <button
                  onClick={() => {
                    fetchRegisterData();
                    fetchSummary();
                  }}
                  className="bg-primary text-white px-4 py-1.5 rounded text-sm font-semibold"
                >
                  🔄 Reload
                </button>

                <button
                  onClick={handlePrintToPDF}
                  disabled={registerData.length === 0}
                  className="bg-primary disabled:opacity-40 text-white px-4 py-1.5 rounded text-sm font-semibold"
                >
                  📄 Export PDF
                </button>
              </div>
          {loading ? (
            <p className="text-center text-gray-400 py-10">Loading MGT-1…</p>
          ) : error ? (
            <p className="text-center text-red-600 py-10">{error}</p>
          ) : registerData.length === 0 ? (
            <p className="text-center text-gray-400 py-10">
              No MGT-1 data found
            </p>
          ) : (
            <div ref={printRef}>
       
              {/* SUMMARY PAGE (Portrait) */}
              <div style={PAGE} className="shadow-md mx-auto">
                <ShareSummaryTable
                  summaryData={summaryData}
                  registerData={registerData}
                  showAction={false}
                />
              </div>

              {/* FOLIO PAGES (Portrait, table will auto-break to next page if needed) */}
              {registerData.map((member, i) => {
                const pd = member.personalDetails || {};
                const md = member.memberMinorDetails || {};
                const ms = md.memberShipDetails || {};
                const addr = member.registeredOfficeAddress || {};
                const holdings = member.mgt1ShareHolding || [];

                return (
                  <div key={i} style={PAGE} className="shadow-md mx-auto mb-6">
                    {/* HEADER */}
                    <div style={{ textAlign: "center", marginBottom: "4px" }}>
                      <div style={{ fontSize: "11px", fontWeight: "bold" }}>
                        Form No. MGT - 1
                      </div>
                      <div style={{ fontSize: "10px", fontWeight: "bold" }}>
                        Register of members
                      </div>
                      <div style={{ fontSize: "9px", marginTop: "1px" }}>
                        [Pursuant to section 88 (1)(a) of the Companies Act,
                        2013 and rule 3(1) of the Companies (Management and
                        Administration) Rules, 2014]
                      </div>
                    </div>

                    {/* COMPANY INFO */}
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "12px",
                        marginBottom: "4px",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td style={{ ...LABEL_CELL, fontWeight: "bold" }}>
                            Name of the Company:
                          </td>
                          <td style={VALUE_CELL}>{val(member.companyName)}</td>
                        </tr>
                        <tr>
                          <td style={LABEL_CELL}>Registered office address:</td>
                          <td style={VALUE_CELL}>
                            {addr.address
                              ? `${addr.address}, ${addr.city || ""}, ${addr.state || ""}, ${addr.pincode || ""}`
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan={2}
                            style={{
                              fontSize: "7px",
                              fontStyle: "italic",
                              color: "#555",
                            }}
                          >
                            TO BE MAINTAINED SEPARATELY FOR EACH CLASS OF SHARES
                          </td>
                        </tr>
                        <tr>
                          <td style={LABEL_CELL}>Class of shares:</td>
                          <td style={VALUE_CELL}>{val(member.shareClass)}</td>
                        </tr>
                        <tr>
                          <td style={LABEL_CELL}>
                            Nominal value per share (in Rs.):
                          </td>
                          <td style={VALUE_CELL}>
                            {val(member.nominalValuePerShare)}
                          </td>
                        </tr>
                        <tr>
                          <td style={LABEL_CELL}>Total shares held:</td>
                          <td style={VALUE_CELL}>
                            {val(member.totalSharesHeld)}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...LABEL_CELL, fontWeight: "bold" }}>
                            FOLIO NO.
                          </td>
                          <td style={{ ...VALUE_CELL, fontWeight: "bold" }}>
                            {val(member.folio_no)}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* PERSONAL + MINOR (2-col) */}
                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        marginBottom: "4px",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginBottom: "5px",
                            borderBottom: "1px solid #000",
                            paddingBottom: "4px",
                            fontSize: "10px",
                          }}
                        >
                          Personal details
                        </div>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            fontSize: "12px",
                          }}
                        >
                          <tbody>
                            <PersonalRow
                              label="Name of the member"
                              value={pd.memberName}
                            />
                            <PersonalRow
                              label="Name of joint holders"
                              value={pd.jointHoldersName}
                            />
                            <PersonalRow
                              label="Address"
                              value={pd.addressOrRegisteredAddress}
                            />
                            <PersonalRow label="E-mail" value={pd.emailId} />
                            <PersonalRow
                              label="CIN / Reg. No."
                              value={pd.cinOrRegistrationNo}
                            />
                            <PersonalRow
                              label="UID No"
                              value={pd.uniqueIdentificationNo}
                            />
                            <PersonalRow
                              label="Father/Mother/Spouse"
                              value={pd.parentOrSpouseName}
                            />
                            <PersonalRow label="Status" value={pd.status} />
                            <PersonalRow
                              label="Occupation"
                              value={pd.occupation}
                            />
                            <PersonalRow label="PAN" value={pd.panNo} />
                            <PersonalRow
                              label="Nationality"
                              value={pd.nationality}
                            />
                          </tbody>
                        </table>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: "bold",
                            marginBottom: "5px",
                            borderBottom: "1px solid #000",
                            paddingBottom: "4px",
                            fontSize: "10px",
                          }}
                        >
                          In case member is a minor,
                        </div>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            fontSize: "12px",
                          }}
                        >
                          <tbody>
                            <PersonalRow
                              label="Guardian"
                              value={md.guardianName}
                            />
                            <PersonalRow
                              label="DOB of minor"
                              value={fmt(md.dateOfBirthOfMinor)}
                            />
                            <PersonalRow
                              label="Date of membership"
                              value={fmt(md.dateOfBecomingMember)}
                            />
                            <div>Details of membership</div>
                            <PersonalRow
                              label="Declaration (sec 89)"
                              value={fmt(ms.declarationDateUnderSection89)}
                            />
                            <PersonalRow
                              label="Beneficial owner"
                              value={ms.beneficialOwnerNameAndAddress}
                            />
                            <PersonalRow
                              label="Nomination date"
                              value={fmt(ms.nominationReceiptDate)}
                            />
                            <PersonalRow
                              label="Nominee"
                              value={ms.nomineeNameAndAddress}
                            />
                            <PersonalRow
                              label="Abeyance"
                              value={ms.sharesKeptInAbeyance}
                            />
                            <PersonalRow label="Lien" value={ms.lienOnShares} />
                            <PersonalRow
                              label="Cessation"
                              value={fmt(ms.dateOfCessationOfMembership)}
                            />
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* INSTRUCTIONS */}
                    <div
                      style={{
                        marginTop: "4px",
                        marginBottom: "4px",
                        fontSize: "10px",
                      }}
                    >
                      <div style={{ fontWeight: "bold", marginBottom: "1px" }}>
                        Instructions
                      </div>
                      <div>
                        Particulars of dividend mandates, power of attorney and
                        other instructions, if any:
                      </div>
                      <div>Instruction for sending notices etc., if any:</div>
                    </div>

                    {/* SHARE HOLDING TABLE - SPLIT INTO TWO PARTS FOR READABILITY */}
                    <div>
                      <div
                        style={{
                          fontWeight: "bold",
                          marginBottom: "4px",
                          fontSize: "10px",
                        }}
                      >
                        Details of share holding (Part 1 - Allotment Details)
                      </div>

                      {/* PART 1: Columns 1-10 (Allotment section) */}
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "6px",
                          marginBottom: "10px",
                        }}
                      >
                        <thead>
                          <tr style={{ background: "#f0f0f0" }}>
                            <th style={TH}>Allotment No./ Transfer No.</th>
                            <th style={TH}>Date of allotment/</th>
                            <th style={TH}>No. of shares allotted</th>
                            <th style={TH}>Distinctive No From</th>
                            <th style={TH}>Distinctive No To</th>
                            <th style={TH}>Folio of transferor</th>
                            <th style={TH}>Name of transferor</th>
                            <th style={TH}>Date of issue</th>
                            <th style={TH}>Certificate No.</th>
                            <th style={TH}>Lock in period</th>
                          </tr>
                        </thead>
                        <tbody>
                          {holdings.map((t, idx) => (
                            <tr key={idx}>
                              <td style={TD}>{val(t.allotmentOrTransferNo)}</td>
                              <td style={TD}>
                                {fmt(t.dateOfAllotmentOrTransfer)}
                              </td>
                              <td style={TD}>
                                {val(t.numberOfSharesAllottedOrTransferred)}
                              </td>
                              <td style={TD}>
                                {val(t.distinctiveNumberFromTo?.from)}
                              </td>
                              <td style={TD}>
                                {val(t.distinctiveNumberFromTo?.to)}
                              </td>
                              <td style={TD}>{val(t.folioOfTransferor)}</td>
                              <td style={TD}>{val(t.nameOfTransferor)}</td>
                              <td style={TD}>
                                {fmt(t.dateOfIssueOrEndorsement)}
                              </td>
                              <td style={TD}>{val(t.certificateNo)}</td>
                              <td style={TD}>{val(t.lockInPeriod)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* PART 2: Columns 11-23 (Payment & Transfer section) */}
                      <div
                        style={{
                          fontWeight: "bold",
                          marginBottom: "4px",
                          fontSize: "10px",
                        }}
                      >
                        Details of share holding (Part 2 - Payment & Transfer
                        Details)
                      </div>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "10px",
                        }}
                      >
                        <thead>
                          <tr style={{ background: "#f0f0f0" }}>
                            <th style={TH}>Ammount Payable (₹)</th>
                            <th style={TH}>Amount Paid/ Deemed (₹)</th>
                            <th style={TH}>Amount Due (₹)</th>
                            <th style={TH}>Consideration other than cash</th>
                            <th style={TH}>Date of transfer</th>
                            <th style={TH}>No. shares transferred</th>
                            <th style={TH}>Transfer No From</th>
                            <th style={TH}>Transfer No To</th>
                            <th style={TH}>Folio of transferee</th>
                            <th style={TH}>Name of transferee</th>
                            <th style={TH}>Balance shares</th>
                            <th style={TH}>Remarks</th>
                            <th style={TH}>Auth/ Signature</th>
                          </tr>
                        </thead>
                        <tbody>
                          {holdings.map((t, idx) => (
                            <tr key={idx}>
                              <td style={TD}>
                                {cur(t.amount?.payable_Amount)}
                              </td>
                              <td style={TD}>
                                {cur(t.amount?.paidOrDeemed_Amount)}
                              </td>
                              <td style={TD}>{cur(t.amount?.due_Amount)}</td>
                              <td style={TD}>
                                {val(t.considerationOtherThanCash)}
                              </td>
                              <td style={TD}>
                                {fmt(t.dateOfTransferOrTransmission)}
                              </td>
                              <td style={TD}>
                                {val(t.numberOfSharesTransferredOrTransmitted)}
                              </td>
                              <td style={TD}>
                                {val(t.transferDistinctiveNoFromTo?.from)}
                              </td>
                              <td style={TD}>
                                {val(t.transferDistinctiveNoFromTo?.to)}
                              </td>
                              <td style={TD}>{val(t.folioOfTransferee)}</td>
                              <td style={TD}>{val(t.nameOfTransferee)}</td>
                              <td style={TD}>
                                {val(t.balanceSharesAfterTransaction)}
                              </td>
                              <td style={TD}>{val(t.remarks)}</td>
                              <td style={TD}>
                                {val(t.authenticationOrSignature)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}

      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50"
          style={{ paddingTop: "40px" }}
          onClick={(e) => {
            if (e.target === e.currentTarget) setModalOpen(false);
          }}
        >
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto relative">
            <div className="mt-3 px-5  flex justify-between rounded-t-xl ">
              <div>
                <h3 className="font-bold text-base text-gray-600">+ Add New Share Holding</h3>
                <p className="text-gray-500 text-xs">
                  Folio No: <strong>{selectedFolioNo}</strong>
                </p>
              </div>
              <button
                onClick={() => setModalOpen(false)}
                className="text-red-800 hover:text-red-600 text-xl leading-none"
              >
                &times;
              </button>
            </div>
 <hr className=" border-gray-800" />
            <div className="p-3">
              {submitError && (
                <div className="bg-red-50 border border-red-300 text-red-700 text-xs rounded px-3 py-2 mb-4">
                  ⚠️ {submitError}
                </div>
              )}
              <div className="grid grid-cols-2 gap-x-5 gap-y-3">
                {FIELDS.map((f) => (
                  <div key={f.key}>
                    <label className="block text-xs font-semibold text-gray-600 mb-0.5">
                      {f.label}
                    </label>
                    <input
                      type={f.type || "text"}
                      value={form[f.key]}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          [f.key]: e.target.value,
                        }))
                      }
                      disabled={submitting}
                      className="w-full border border-gray-300 rounded px-2.5 py-1.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-400 disabled:bg-gray-100"
                      placeholder={
                        f.type === "date"
                          ? "yyyy-mm-dd"
                          : f.type === "number"
                            ? "0"
                            : "—"
                      }
                    />
                  </div>
                ))}
              </div>
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setModalOpen(false)}
                  disabled={submitting}
                  className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  disabled={submitting}
                  className="px-5 py-2 bg-primary disabled:opacity-50 text-white text-sm font-semibold rounded flex items-center gap-2"
                >
                  {submitting && (
                    <span className="inline-block w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  )}
                  {submitting ? "Saving…" : "💾 Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const PersonalRow = ({ label, value }) => (
  <tr>
    <td
      style={{
        paddingRight: "4px",
        whiteSpace: "nowrap",
        verticalAlign: "top",
        width: "48%",
        fontSize: "6.5px",
      }}
    >
      {label}
    </td>
    <td style={{ verticalAlign: "top", fontSize: "6.5px" }}>
      {value !== null && value !== undefined && value !== ""
        ? String(value)
        : "-"}
    </td>
  </tr>
);

export default Mgt1RegisterViewer;
